import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

// Injecter le token JWT automatiquement
API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Rediriger vers login si 401
API.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// ─── Auth ────────────────────────────────────────────────────
export const login = (username, password) =>
  API.post('/auth/login', { username, password });

// ─── Events ──────────────────────────────────────────────────
export const getEvents = () => API.get('/events');
export const getEvent = id => API.get(`/events/${id}`);
export const createEvent = data => API.post('/events', data);
export const updateEvent = (id, data) => API.put(`/events/${id}`, data);
export const deleteEvent = id => API.delete(`/events/${id}`);

// ─── Guests ──────────────────────────────────────────────────
export const getGuests = (event_id, status) =>
  API.get('/guests', { params: { event_id, status } });
export const importGuests = (event_id, file) => {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('event_id', event_id);
  return API.post('/guests/import', fd);
};
export const deleteGuest = id => API.delete(`/guests/${id}`);
export const regenerateQr = id => API.post(`/guests/${id}/regenerate-qr`);

// ─── Campaigns ───────────────────────────────────────────────
export const getCampaigns = event_id =>
  API.get('/campaigns', { params: { event_id } });
export const createCampaign = data => API.post('/campaigns', data);
export const launchCampaign = id => API.post(`/campaigns/${id}/launch`);
export const getCampaignProgress = id => API.get(`/campaigns/${id}/progress`);

// ─── Upload ──────────────────────────────────────────────────
export const uploadFlyer = file => {
  const fd = new FormData();
  fd.append('file', file);
  return API.post('/upload/flyer', fd);
};

// ─── Scan stats ──────────────────────────────────────────────
export const getScanStats = event_id => API.get(`/scan/stats/${event_id}`);
export const getRecentArrivals = event_id => API.get(`/scan/recent/${event_id}`);

// ─── Webhook setup ───────────────────────────────────────────
export const setupWebhook = () => API.post('/webhook/setup');

export default API;
